export class TaxRate {
    countryCode: string;
    vatRate: number;
}